import React from 'react';
import { Link } from 'react-router-dom';

export const Header = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80">
      <div className="container mx-auto flex h-20 items-center justify-between px-4">
        <Link to="/" className="flex items-center space-x-3 transition-transform hover:scale-105">
          <img 
            src="/kindred-logo-new.png" 
            alt="Kindred Pharmaceuticals Logo" 
            className="h-16 w-auto object-contain"
            style={{ mixBlendMode: 'darken', filter: 'contrast(1.2)' }}
          />
        </Link>

        <nav className="flex items-center space-x-8">
          <Link to="/" className="text-sm font-medium text-gray-700 transition-colors hover:text-blue-600">
            Products
          </Link>
          <Link to="/about" className="text-sm font-medium text-gray-700 transition-colors hover:text-blue-600">
            About Us
          </Link>
          <Link to="/contact" className="text-sm font-medium text-gray-700 transition-colors hover:text-blue-600">
            Contact
          </Link>
        </nav>
      </div>
    </header>
  );
};
